import { useRouter } from 'next/router';

import { PedagogieRoles } from '@inspire/data/static/pedagogie';
import Page from '@inspire/ui/chakra/layout/Page';
import { Box } from '@chakra-ui/react';

import { monCompteTabPath } from 'lib/paths';
import { useMyProfile, useUser } from 'lib/hooks';
import ResponsiveTabs from './ResponsiveTabs';
import { useEffect, useState } from 'react';

export const ProfilePageWrapper = ({ children }) => {
  const { isUserLoading, isProf } = useUser();
  const { myProfile } = useMyProfile();

  const { pathname } = useRouter();

  const tabs = [
    { value: 'mon-profil', label: 'Mon profil' },
    { value: 'preferences', label: 'Préférences' },
  ];

  const [subtitle, setSubtitle] = useState(undefined);

  useEffect(() => {
    if (isProf && myProfile) {
      if (myProfile.fonction === 'autre') {
        setSubtitle(myProfile.fonctionAutre);
      } else {
        setSubtitle(PedagogieRoles[myProfile.fonction]);
      }
    }
  });

  return (
    <Page
      title="Mon compte"
      subtitle={subtitle}
      isLoading={isUserLoading}
      withPanel
      headingIsTitle
    >
      <ResponsiveTabs
        tabs={tabs}
        currentTab={pathname.split('/')[2]}
        getPath={monCompteTabPath}
        mobileThreshold={960}
      />
      <Box py={4} px={[0, 2, 4]}>
        {children}
      </Box>
    </Page>
  );
};
